import { NgClass } from "@angular/common";
import { Component, ElementRef, HostListener, inject, ViewChild } from "@angular/core";
import { SvgIcon, SvgIconMap } from "@ponder-shared/utils/svgIcons";

@Component({
    selector: "confirmation-modal",
    imports: [NgClass],
    templateUrl: "./confirmation-modal.component.html"
})
export class ConfirmationModalComponent {
    @ViewChild("confirmationModal") private confirmationModalRef!: ElementRef<HTMLElement>;
    private readonly elementRef = inject(ElementRef<HTMLElement>);

    public title: string = "Modal Title";
    public body: string = "Body";
    public serious: string = "";
    public centered: boolean = false;

    public onCancelCallback?: Function;
    public onAcceptCallback?: Function;

    public readonly closeSvgIcon: string = SvgIconMap.get(SvgIcon.Close)!;

    private onClose(): void {
        this.elementRef.nativeElement.remove();
    }

    public onCloseClicked(): void {
        this.onClose();
        
        if (this.onCancelCallback) {
            this.onCancelCallback();
        }
    }

    public onConfirmClicked(): void {
        this.onClose();

        if (this.onAcceptCallback) {
            this.onAcceptCallback();
        }
    }

    // -------------------------------------------------------------------------------------
    // Global Events
    // -------------------------------------------------------------------------------------

    private mouseDownOutside: boolean = false;

    @HostListener("document:keydown.escape", ["$event"]) 
    private onEscapePressed(event: KeyboardEvent): void {
        this.onCloseClicked();
    }

    @HostListener("document:mousedown", ["$event"])
    private onGlobalMouseDown(event: MouseEvent): void {
        if (this.confirmationModalRef && !this.confirmationModalRef.nativeElement.contains(event.target as HTMLInputElement)) {
            this.mouseDownOutside = true;
        }
    }

    @HostListener("document:mouseup", ["$event"])
    private onGlobalMouseUp(event: MouseEvent): void {
        // Did the user click outside of our modal panel?
        if (this.mouseDownOutside && this.confirmationModalRef && !this.confirmationModalRef.nativeElement.contains((event.target as HTMLInputElement))) {
            this.onCloseClicked();
        }

        this.mouseDownOutside = false;
    }
}